import type { SxProps } from '@mui/material';

export const MENU_ITEM_SX = {
    mx: 1,
    px: 1.25,
    minHeight: 36,
    borderRadius: '8px',
    transition: 'background 120ms ease',
    '&:hover': { bgcolor: 'action.hover' }
} as const satisfies SxProps;
export const MENU_ICON_BOX_SX = {
    width: 28,
    minWidth: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
} as const satisfies SxProps;

export const MENU_ICON_SX = {
    fontSize: 18,
    color: 'text.secondary',
    opacity: 0.9
} as const satisfies SxProps;

export const MENU_LABEL_SX = {
    fontSize: '0.85rem',
    color: 'text.primary',
    lineHeight: 1
} as const satisfies SxProps;

export const SUBTLE_DIVIDER_SX = { width: '100%', borderColor: 'divider' } as const satisfies SxProps;
